angular.module('app.factories').factory('projectsListFilterFactory', ($translate, $state, $log, listFilter) => {
    const projectsListFilter = listFilter;

    projectsListFilter
        .setAttributes({
            name: 'projectsListFilter',
            providers: ['filterAreasOptions', 'projectTypeOptions', 'projectStatusOptions', 'usersOptions', 'clientOptionsForProjectsFilter', 'investmentOptionsForProjectsFilter'],
        })
        .setFields({
            // row 1
            filter: {
                type: 'text',
                class: 'uk-width-medium-6-10',
                label: $translate.instant('search'),
                default: '',
            },
            search_in: {
                type: 'checkbox-list',
                class: 'uk-width-medium-4-10',
                label: $translate.instant('search_in'),
                names: [
                    { name: 'name', label: $translate.instant('projects.name') },
                    { name: 'symbol', label: $translate.instant('projects.symbol') },
                    { name: 'client.name', label: $translate.instant('projects.client_id') },
                    { name: 'description', label: $translate.instant('projects.notes') },
                ],
                default: { name: true },
            },

            // row 2
            area: {
                type: 'multilist',
                operator: 'in',
                class: 'uk-width-medium-5-10',
                label: $translate.instant('areas'),
                optionsProvider: 'filterAreasOptions',
                options: [],
                default: '',
            },
            type: {
                type: 'multilist',
                operator: 'in',
                class: 'uk-width-medium-5-10',
                label: $translate.instant('projects.type'),
                maxItems: 4,
                optionsProvider: 'projectTypeOptions',
                options: [],
                default: '',
            },

            // row 3
            status_id: {
                type: 'multilist',
                operator: 'in',
                class: 'uk-width-medium-5-10',
                label: $translate.instant('projects.status_id'),
                optionsProvider: 'projectStatusOptions',
                options: [],
                default: '',
            },
            owner_id: {
                type: 'multiuserlist',
                operator: 'in',
                class: 'uk-width-medium-5-10',
                label: $translate.instant('projects.owner_id'),
                optionsProvider: 'usersOptions',
                options: [],
                default: '',
            },

            // row 4
            client_id: {
                type: 'clientslist',
                class: 'uk-width-medium-5-10',
                label: $translate.instant('projects.client_id'),
                optionsProvider: 'clientOptionsForProjectsFilter',
                options: [],
                default: '',
            },
            investment_id: {
                type: 'multilist',
                operator: 'in',
                class: 'uk-width-medium-5-10',
                label: $translate.instant('projects.investment_id'),
                optionsProvider: 'investmentOptionsForProjectsFilter',
                options: [],
                default: '',
            },
        })
        .onRefresh(() => {
            const filterParams = projectsListFilter.getValues(true);
            projectsListFilter.updateClientsOptions('client_id');
            $log.debug('--> apply filter', filterParams);
            $state.applyFilter(filterParams);
        })
        .ready();

    return projectsListFilter;
});
